import { render, staticRenderFns } from "./PecHistoryEditor.vue?vue&type=template&id=b4926526"
import script from "./PecHistoryEditor.vue?vue&type=script&lang=js"
export * from "./PecHistoryEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports